import styled from 'styled-components'
import { breakpoints } from '../../../constants'
import Browser from '../../../services/Browser'
import {
	BLUE,
	LIGHTGRAY,
	LIGHTERGRAY,
	PRIMARY_LIGHT,
	PRIMARY_COLOR,
} from '../../../styles/colors.style'

export const StyledPlansTable = styled.div`
	.buttons {
		font-size: 18px;
		display: flex;
		flex-wrap: wrap;
		justify-content: center;

		.button {
			border-bottom: 2px solid ${BLUE};
			padding: 10px 15px;
			margin: 0 5px;
			margin-top: 15px;
			white-space: nowrap;
			text-align: center;
			flex-basis: 22%;
			transition: all 0.2s;

			@media screen and (min-width: ${breakpoints.MOBILE}px) {
				display: none;
			}

			&.active {
				color: #fff;
				background: ${BLUE};
				transition: all 0.2s;
			}
		}
	}

	.table {
		font-size: 18px;
		display: flex;
		margin-top: 25px;
		text-align: center;

		@media screen and (min-width: ${breakpoints.MOBILE}px) {
			margin-top: 0;
		}

		img {
			@media screen and (min-width: ${breakpoints.MOBILE}px) {
				height: 40px;
				width: auto;
			}
		}

		.column {
			border-radius: 5px;
			border: 1px solid ${LIGHTGRAY};
			background: ${LIGHTERGRAY};
			display: none;
			flex-direction: column;
			justify-content: space-between;
			transition: all 0.2s;
			width: ${Browser.isIE() ? '20%' : null};

			@media screen and (min-width: ${breakpoints.MOBILE}px) {
				display: flex;

				&:not(:last-child) {
					margin-right: 5px;
				}
			}

			&.active {
				display: flex;

				@media screen and (min-width: ${breakpoints.MOBILE}px) {
					border-color: ${PRIMARY_COLOR};
					box-shadow: 0px 5px 12px -2px rgba(0, 0, 0, 0.55);
				}
			}

			& > button {
				font-size: 18px;
				width: calc(100% - 10px);
				margin: 10px 5px 5px;
			}

			& > *:not(:last-child) {
				margin-bottom: 5px;
				flex: ${Browser.isIE() ? null : '1'};
			}

			& > * {
				line-height: 1.5;
				padding: 10px;
				border-radius: 5px;

				&.monthly,
				&.yearly {
					transition: all 0.2s;

					&.disabled {
						opacity: 0.5;
					}

					&:not(.disabled):hover {
						cursor: pointer;
						transition: all 0.2s;
					}

					&:not(.disabled).active {
						font-size: 26px;
						font-weight: 800;
						transition: all 0.2s;
					}
				}

				&.monthly {
					color: ${BLUE};
					border: 1px solid ${BLUE};
					width: calc(100% - 10px);
					margin-right: auto;
					margin-left: auto;

					&:not(.disabled):hover {
						color: ${BLUE};
						background: #fff;
						transition: all 0.2s;
					}

					&:not(.disabled).active {
						color: #fff;
						background: ${BLUE};
						font-size: 26px;
					}
				}

				&.yearly {
					border: 1px solid ${BLUE};
					width: calc(100% - 10px);
					margin-right: auto;
					margin-left: auto;
					margin-bottom: 5px;

					&:not(.disabled):hover {
						color: #fff;
						background: ${BLUE};
						transition: all 0.2s;

						& > * {
							color: #fff;
						}
					}

					&:not(.disabled).active {
						color: #fff;
						background: ${BLUE};
						font-size: 20px !important;

						> * {
							color: #fff;
						}
					}
				}

				.fa-check {
					color: ${PRIMARY_LIGHT};
				}
			}

			.header {
				display: none;

				@media screen and (min-width: ${breakpoints.MOBILE}px) {
					color: ${PRIMARY_COLOR};
					display: block;
					line-height: 1;
					box-shadow: 0px 5px 12px -2px rgba(0, 0, 0, 0.55);
					position: relative;

					.plan-points {
						font-size: 4.2rem;
					}
				}
			}
		}
	}
`
